import React, { useMemo } from 'react';
import { SolutionOutlined } from '@ant-design/icons';
import { Popover } from 'antd';
import { IBook } from '../../../section/Common/types/types';
import { ACTIONS, useActions } from '../../../context/Actions.context';
import { GAEventIdentifier, GAEventName } from '../../../section/Common/constants';

interface IProps {
  book: IBook;
  id: string;
  label?: string;
}

const ToPodiumTitle: React.FC<IProps> = ({ book, id, label = 'Title' }) => {
  const { setAction } = useActions();

  return (
    <Popover
      placement='topLeft'
      content={<div className='popover-content'>{`Send ${label} to Podium Titles`}</div>}
      trigger='hover'
    >
      <SolutionOutlined
        data-testid='podium-list-action'
        onClick={(e) => {
          e.stopPropagation();
          globalThis.gtag('event', GAEventName.click, {
            identifier: GAEventIdentifier.titletoPodiumTitles,
            value: book.ASIN,
            book_name: book.Title
          });
          setAction({ book, id, type: ACTIONS.podiumTitle });
        }}
        className='actions-icons actions-icons-podium-title'
      />
    </Popover>
  );
};

export default React.memo(ToPodiumTitle);